import { type TezosToolkit } from "@taquito/taquito";
import { type SignTransactionOptions } from "@umami/chains";
import { useAsyncActionHandler, useSelectedNetwork } from "@umami/state";

import { getMnemonicFromOptions } from "../utils";

import { saplingWorkerService } from "@/services/saplingWorkerService";
import { type ShieldTransaction } from "@/services/types";

export const useEstimateShieldFee = () => {
  const network = useSelectedNetwork();
  const { isLoading, handleAsyncAction } = useAsyncActionHandler();

  const estimateFee = (
    transaction: ShieldTransaction,
    { toolkit, options }: { toolkit: TezosToolkit; options: SignTransactionOptions }
  ) =>
    handleAsyncAction(async () => {
      const contractAddress = network.saplingContractAddress ?? "";
      const mnemonic = getMnemonicFromOptions(options);

      const { amount } = transaction;
      const shieldedParam = await saplingWorkerService.prepareShieldedTransaction({
        mnemonic,
        contractAddress,
        rpcUrl: network.rpcUrl,
        transaction,
      });

      const contract = await toolkit.contract.at(contractAddress);
      const txParams = contract.methodsObject.default([shieldedParam]).toTransferParams({ amount });
      const estimate = await toolkit.estimate.transfer(txParams);

      const totalFee = estimate.suggestedFeeMutez || estimate.totalCost || 0;

      return { fee: totalFee, toolkit, shieldedTx: shieldedParam };
    });

  return { estimateFee, isLoading };
};
